export const DragConfig = {
  forceAutoScrollFallback: true,
  scrollSensitivity: 100,
  scrollSpeed: 30,
} as const

export enum ContentType {
  Collection = 'collection',
  Application = 'application',
  Block = 'block',
}
